import React from "react";
import OldLandUsePlinth from "./Plinth/OldLandUsePlinth";
import OldLandUseCompletion from "./Completion/OldLandUseCompletion";

const SubStep5 = ({ formData, module, handleSubTabChange, handleTabChange, t, isEmployee, isApproved }) => {
  console.log("module", module);
  return (
    <div>
      {module === "Plinth" ? (
        <OldLandUsePlinth
          formData={formData}
          t={t}
          handleSubTabChange={handleSubTabChange}
          handleTabChange={handleTabChange}
          isApproved={isApproved}
          isEmployee={isEmployee}
        />
      ) : (
        <React.Fragment>
          <OldLandUseCompletion
            formData={formData}
            handleSubTabChange={handleSubTabChange}
            handleTabChange={handleTabChange}
            isApproved={isApproved}
            isEmployee={isEmployee}
            t={t}
          />
        </React.Fragment>
      )}
    </div>
  );
  z;
};

export default SubStep5;
